// @flow

type TCertificate = {
    networkList: string[],
    textToPublish: {
        content?: string,
        hashTag?: string,
        title?: string,
    },
    url: ?string,
};

type TCertificateState = TCertificate;
const initialState: TCertificateState = {
    networkList: [],
    textToPublish: {
        content: '',
        hashTag: '',
        title: '',
    },
    url: null,
};

type TSetCertificate = {payload: TCertificate, type: 'SET_CERTIFICATE'};

type TCertificateActionList = TSetCertificate;

function certificateReducer(state: TCertificateState = initialState, {type, payload}: TCertificateActionList) {
    switch (type) {
        case 'SET_CERTIFICATE':
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}

export {certificateReducer};
export type {TSetCertificate, TCertificate, TCertificateState};
